import NotFound              from "../pages/NotFound";
import Home                  from "../pages/home/page";
import Wallet                from "../pages/wallet/page";
import Transactions          from "../pages/transactions/page";
import Auth                  from "../pages/auth/page";
import BuyCrypto             from "../pages/buy/page";
import SellCrypto            from "../pages/sell/page";
import WithdrawCrypto        from "../pages/withdraw-crypto/page";
import WithdrawNaira         from "../pages/withdraw-naira/page";
import OnboardingGuard       from "../components/OnboardingGuard";
import Onboarding            from "../pages/onboarding/page";
import BuyCallback           from "../pages/buy/BuyCallback";
import SellCallback          from "../pages/sell/SellCallback";
import TransactionDetail     from "../pages/transactions/TransactionDetail";
import KYCPage               from "../pages/kyc/page";
import SupportPage           from "../pages/support/page";
import BillsPage             from "../pages/bills/BillsPage";
import AirtimePage           from "../pages/bills/AirtimePage";
import DataPage              from "../pages/bills/DataPage";
import ElectricityPage       from "../pages/bills/ElectricityPage";
import TVPage                from "../pages/bills/TVPage";
import BillSuccessPage       from "../pages/bills/BillSuccessPage";
import FiatDeposit           from "../pages/deposit/FiatDeposit";
import GoogleCallback        from "../pages/auth/GoogleCallback";
import TermsPrivacy          from "../pages/termsPrivacy/page";
import ResetPasswordPage     from "../pages/auth/ResetPasswordPage";
import RewardsPage           from "../pages/reward/page";
import DepositPage           from "../pages/deposit/page";
import DepositCrypto         from "../pages/deposit/DepositCrypto";
import DepositVerify         from "../pages/deposit/DepositVerify";
import NotificationsPage     from "../pages/notifications/notificationPage";   // notification inbox bell
import ServiceRoute          from "../components/ServiceRoute";
import CreatePinPage         from "../pages/pin/page";
import ChangePinPage         from "../pages/pin/ChangePinPage";
import SavedBanksPage        from "../pages/wallet/SavedBanksPage";

// ── New profile / settings pages ─────────────────────────────
import ProfilePage           from "../pages/profile/ProfilePage";          // replaces old Profile
import PersonalInfoPage      from "../pages/profile/PersonalInfoPage";     // was PersonalInfoModal
import NotificationPrefsPage from "../pages/profile/NotificationsPage";    // notification preferences
import InternalTransferPage from "../pages/Transfer/page";
import SavingsPage from "../pages/Savings/SavingsPage";
import CreateSavingsGoalPage from "../pages/Savings/CreateSavingsGoalPage";
import SavingsGoalDetailPage from "../pages/Savings/SavingsGoalDetailPage";
import PublicPayPage from "../pages/PaymentLinks/PublicPayPage";
import MyPaymentLinksPage from "../pages/PaymentLinks/MyPaymentLinksPage";
import CreatePaymentLinkPage from "../pages/PaymentLinks/CreatePaymentLinkPage";
import CompanyDashboardPage from "../pages/Company/CompanyDashboardPage";
import CompanyCreatePage from "../pages/Company/CompanyCreatePage";
import StaffManagementPage from "../pages/Company/StaffManagementPage";
import PayrollRunPage from "../pages/Company/PayrollRunPage";
import CardPage from "../pages/card/page";
import MorePage from "../pages/more/page";
import TeamRolesPage from "../pages/Company/TeamRolesPage";
import CompanySettingsPage from "../pages/Company/CompanySettingsPage";
import CompanyEntryPage from "../pages/Company/CompanyEntryPage";
import CompanyOnboardingPage from "../pages/Company/CompanyOnboardingPage";
import CompanyInviteAcceptPage from "../pages/Company/CompanyInviteAcceptPage";

const routes = [
  {
    element: <OnboardingGuard />,
    children: [

      // ── Always accessible ───────────────────────────────────
      { path: "/",                    element: <Home /> },
      { path: "/home",                element: <Home /> },
      { path: "/wallet",              element: <Wallet /> },
      { path: "/transactions",        element: <Transactions /> },
      { path: "/transaction/:id",     element: <TransactionDetail /> },
      { path: "/support",             element: <SupportPage /> },
      { path: "/terms-privacy",       element: <TermsPrivacy /> },
      { path: "/notifications",       element: <NotificationsPage /> },
      { path: "/auth",                element: <Auth /> },
      { path: "/reset-password",      element: <ResetPasswordPage /> },
      { path: "/auth/google/success", element: <GoogleCallback /> },

      // ── Profile & Settings ──────────────────────────────────
      { path: "/profile",                       element: <ProfilePage /> },
      { path: "/profile/personal",              element: <PersonalInfoPage /> },
      { path: "/profile/notifications",         element: <NotificationPrefsPage /> },
      { path: "/saved-banks",                   element: <SavedBanksPage /> },

      // ── Trading ─────────────────────────────────────────────
      {
        element: <ServiceRoute serviceKey="trading" />,
        children: [
          { path: "/buy",         element: <BuyCrypto /> },
          { path: "/buy-crypto",  element: <BuyCallback /> },
          { path: "/sell",        element: <SellCrypto /> },
          { path: "/sell-crypto", element: <SellCallback /> },
        ],
      },

      // ── Crypto deposits ─────────────────────────────────────
      {
        element: <ServiceRoute serviceKey="deposits" />,
        children: [
          { path: "/deposit-crypto",        element: <DepositCrypto /> },
          { path: "/deposit-crypto/verify", element: <DepositVerify /> },
        ],
      },

      // ── Internal transfer ─────────────────────────────────────
      {
        element: <ServiceRoute serviceKey="internal_transfer" />,
        children: [
          { path: "/internal-transfer",        element: <InternalTransferPage /> },
        ],
      },

      // ── Savings ─────────────────────────────────────
      {
        element: <ServiceRoute serviceKey="savings" />,
        children: [
          { path: "/savings",      element: <SavingsPage /> },
          { path: "/savings/new",  element: <CreateSavingsGoalPage /> },
          { path: "/savings/:id",  element: <SavingsGoalDetailPage /> },
        ],
      },

      {
        element: <ServiceRoute serviceKey="payroll" />,
        children: [
          { path: "/business/landing",                         element: <CompanyEntryPage /> },
          { path: "/business",                         element: <CompanyDashboardPage /> },
          { path: "/business/new",                     element: <CompanyCreatePage /> },
          { path: "/business/join",                     element: <CompanyInviteAcceptPage /> },
          { path: "/business/:companyId/staff",        element: <StaffManagementPage /> },
          { path: "/business/:companyId/payroll",      element: <PayrollRunPage /> },
          { path: "/business/:companyId/members",      element: <TeamRolesPage /> },
          { path: "/business/:companyId/settings",      element: <CompanySettingsPage /> },
          { path: "/business/:companyId/welcome",      element: <CompanyOnboardingPage /> },
        ],
      },

      
      // Owner — authenticated + service-gated:
      {
        element: <ServiceRoute serviceKey="payment_link" />,
        children: [
          { path: "/payment-link",     element: <MyPaymentLinksPage /> },
          { path: "/payment-link/new", element: <CreatePaymentLinkPage /> },
        ],
      },

      // ── Fiat (Naira) deposit ────────────────────────────────
      {
        element: <ServiceRoute serviceKey="fiat_deposit" />,
        children: [
          { path: "/deposit-fiat",        element: <FiatDeposit /> },
          { path: "/deposit-fiat/verify", element: <DepositVerify /> },
        ],
      },

      // ── Deposit hub ─────────────────────────────────────────
      { path: "/deposit", element: <DepositPage /> },

      // ── Card hub ─────────────────────────────────────────
      { path: "/card", element: <CardPage /> },

      // ── More hub ─────────────────────────────────────────
      { path: "/more", element: <MorePage /> },

      // ── Crypto withdrawals ──────────────────────────────────
      {
        element: <ServiceRoute serviceKey="withdrawals" />,
        children: [
          { path: "/withdraw-crypto", element: <WithdrawCrypto /> },
        ],
      },

      // ── Naira withdrawals ───────────────────────────────────
      {
        element: <ServiceRoute serviceKey="naira_withdrawal" />,
        children: [
          { path: "/withdraw-naira", element: <WithdrawNaira /> },
        ],
      },

      // ── Bill payments ───────────────────────────────────────
      {
        element: <ServiceRoute serviceKey="bills" />,
        children: [
          { path: "/bills",             element: <BillsPage /> },
          { path: "/bills/airtime",     element: <AirtimePage /> },
          { path: "/bills/data",        element: <DataPage /> },
          { path: "/bills/electricity", element: <ElectricityPage /> },
          { path: "/bills/tv",          element: <TVPage /> },
          { path: "/bills/success",     element: <BillSuccessPage /> },
        ],
      },

      // ── Rewards ─────────────────────────────────────────────
      {
        element: <ServiceRoute serviceKey="rewards" />,
        children: [
          { path: "/rewards", element: <RewardsPage /> },
        ],
      },

      // ── KYC & PIN ───────────────────────────────────────────
      {
        element: <ServiceRoute serviceKey="kyc" />,
        children: [
          { path: "/kyc",         element: <KYCPage /> },
          { path: "/create-pin",  element: <CreatePinPage /> },
          { path: "/change-pin",  element: <ChangePinPage /> },
        ],
      },

    ],
  },

  { path: "/pay/:token",      element: <PublicPayPage /> },
  { path: "/pay/:token/done", element: <PublicPayPage /> },
  { path: "/onboarding", element: <Onboarding /> },
  { path: "*",           element: <NotFound /> },
];

export default routes;
